import { HrpBaseClient } from './HrpBaseClient'

export class HrpCorrespondenceClient
 extends HrpBaseClient {
  constructor(
    hrpProxyApiUrl = process.env.HRP_PROXY_API_URL,
    hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME,
    axiosOptions
  ) {
    super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions)
  }

  async getCorrespondenceToProcess(params) {
    await this.createSecureAxiosInstance()

    try {
      const response = await this.secureAxiosInstance.get(
        `/admin/api/correspondence/db/getCorrespondenceToProcess`,
        { params }
      )

      return response.data;
    }
    catch (e) {
      console.log('e: ', e);
      throw e.response
    }

  }

  async getCorrespondence(params) {
    await this.createSecureAxiosInstance()

    try {
      const response = await this.secureAxiosInstance.post(
        `/admin/api/correspondence/classic/getCorrespondence`,
        params
      )

      return response.data;
    }
    catch (e) {
      console.log('e: ', e);
      throw e.response
    }

  }

  async getCorrespondenceIdByClaimHccId({ claimHccId }) {
    await this.createSecureAxiosInstance()

    const searchParams = { claimHccId }

    try {
      const response = await this.secureAxiosInstance.get(
        `/admin/api/correspondence/db/getCorrespondenceIdByClaimHccId`,
        { params: searchParams }
      )

      return response.data;
    }
    catch (e) {
      console.log('e: ', e);
      throw e.response
    }
  }

  async updateStatus({ correspondenceId, status }) {
    await this.createSecureAxiosInstance()

    const params = { correspondenceId, status };

    try {
      const response = await this.secureAxiosInstance.post(
        `/admin/api/correspondence/classic/updateStatus`,
        params
      )

      return response.data;
    }
    catch (e) {
      throw e.response
    }
  }

}
